import { render, staticRenderFns } from "./QuickSearch.vue?vue&type=template&id=83a6db72&scoped=true&"
import script from "./QuickSearch.vue?vue&type=script&lang=js&"
export * from "./QuickSearch.vue?vue&type=script&lang=js&"
import style0 from "./QuickSearch.vue?vue&type=style&index=0&id=83a6db72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a6db72",
  null
  
)

export default component.exports